export default {
  600: 'Error de parámetros',
  510007: 'No tiene permisos',
  510008: 'No ha iniciado sesión',
  510009: 'El usuario no existe',
  510010: 'Error del sistema, por favor, inténtelo de nuevo más tarde',
  510011: 'Error de parámetros de la plataforma',
  510012: 'Acceso ilegal',
  510015:
    'El sistema se está actualizando de 00: 00 a 07: 00, lo que puede causarle inconvenientes, ¡por favor, comprenda!',
  511001: 'Error de código de verificación gráfico',
  511002: 'Error de contraseña dinámica',
  511003: 'Error de contraseña de la cuenta',
  511004: '¡Su cuenta ha sido suspendida debido a operaciones que no cumplen con los requisitos!',
  511005: 'Falta el token de usuario',
  511006: 'La autenticación del token de usuario falló',
  511007: 'El token de usuario ha expirado, por favor, inicie sesión de nuevo',
  511008: 'Los datos no existen',
  511009: 'Error de código de verificación',
  511010: 'Falló el registro del usuario en el centro de registro',
  511011: 'El usuario ya existe',
  511012: 'Falló la verificación de resultado de la operación anterior',
  511013: 'La contraseña antigua no puede estar vacía',
  511014: 'Error de contraseña antiguo',
  511015: 'Las contraseñas ingresadas son inconsistentes',
  511016: 'Error de formato del número de teléfono móvil',
  511017: 'Error de formato del correo electrónico',
  511018: 'Error de código de verificación',
  511019: 'Falló el envío de código de verificación de servicio de mensajes cortos',
  511032: 'La contraseña ya existe, no se permite la configuración directa',
  511033: 'No tiene autoridad para acceder',
  511034: 'Información inválida',
  511039: 'La cuenta actual está vinculada, primero desvincúlala',
  511041: 'Falta la información de la cuenta de terceros, por favor, escanee el código de nuevo',
  511042: 'Ha sido vinculado por otra cuenta',
  511043: 'El número de visitas a la interfaz alcanza el límite máximo',
  511045: 'Los datos son anormales, el usuario de inicio de sesión actual no existe',
  511055: 'El número de teléfono móvil no está registrado',
  511057: 'Por favor, ingrese el código de verificación correcto',
  511058: 'Token inválido',
  511065: 'La solicitud de inicio de sesión ha expirado, por favor, inicie sesión de nuevo',
  511076: 'Los datos se están migrando y la página no es accesible temporalmente',
  511078: 'El correo electrónico no puede estar vacío',
  512002: 'Este video está fuera de línea',
  512017: 'La audiencia incluida en la lista blanca no existe',
  512029: 'Este tema está fuera de línea',
  512033: 'El contenido de reproducción no existe',
  512037: 'La audiencia incluida en la lista blanca no existe',
  512042: 'Error de código de verificación de imagen',
  512051: 'La actividad más animada y envía el límite excedido',
  512063: 'Este tema está fuera de línea',
  512505: 'No se encontró ninguna habitación',
  512506: 'live_token ha expirado',
  512507: 'live_token es incorrecto o ya es inválido',
  512514: 'Se le ha prohibido acceder a la actividad actual',
  512515: 'No se encontraron datos de participación',
  512516: 'Esta cuenta ha entrado en la transmisión en vivo',
  512521: 'La transmisión en vivo no comenzó',
  512522:
    'El anfitrión, invitado o asistente no puede ingresar al lado de visualización durante la transmisión en vivo',
  512523: 'Debe pagar',
  512524: 'La actividad de retransmisión no comenzó a transmitir en vivo',
  512525: 'Debe completar el formulario de registro',
  512526:
    'El tipo de detección y el tipo de restricción de visualización de la actividad son inconsistentes',
  512527: 'Error de contraseña',
  512528: 'Por favor, ingrese la contraseña',
  512529: 'Error de código de invitación',
  512530: 'El código de invitación ha sido usado',
  512531: 'Por favor, ingrese el código de invitación',
  512532:
    'Por favor, ingrese el número de teléfono móvil | correo electrónico | número de trabajo | otros de la lista blanca',
  512535: 'El organizador ha establecido un mecanismo de verificación para esta actividad',
  512536: 'El contenido de reproducción no existe',
  512538:
    'El organizador ha configurado un mecanismo de verificación para esta actividad y la verificación falló',
  512539: 'El método de verificación sólo admite gratis, contraseña y valor K de terceros',
  512540: 'La actividad ha terminado',
  512541:
    '¡El sitio de la actividad está demasiado animado y el número de personas ha excedido el límite superior!',
  512542: 'La información de datos de  visitantes está incompleta',
  512543: 'Este video está fuera de línea',
  512544:
    'Este video está fuera de línea, por favor póngase en contacto con el servicio al cliente si tiene cualquier problema',
  512545: 'Falló la transcodificación de este vídeo',
  512546: 'Este video se está transcodificando',
  512561: 'La información de flujo no existe',
  512570: 'Error de código de verificación de servicio de mensajes cortos',
  512571: 'Los usuarios de flujo deben más de 100G, no pueden ingresar temporalmente',
  512573: 'El correo electrónico ha sido usado por otra persona',
  512579: 'La actividad está bloqueada por el administrador',
  513533: 'Información del token de participación inválida',
  513534: 'El tipo de actividades actuales no coincide, la operación está prohibida',
  513535: 'No se obtuvo información del anfitrión',
  513536: 'Las actividades no coinciden',
  513548: 'El monto de la recompensa excede el límite',
  513550: 'Ruta de la imagen inválida',
  514004: 'El tipo de carga actual contiene un tipo que no está permitido',
  514005: 'El tipo de carga actual no está permitido',
  514006: 'En la ruta de carga contienen caracteres especiales',
  514007: 'El archivo de carga no existe',
  514008: 'El archivo de carga no puede exceder de 2M',
  514009: 'Archivo de carga demasiado grande',
  514014: 'Falló la autorización, por favor, actualice e inténtelo de nuevo'
};
